class Product{
    title = null;
    id = null;
    category = null;
    strategy = null;
    variations = [];

    constructor(id, title, category, strategy, variations){
        this.id = id;
        this.title = title;
        this.category = category;
        this.strategy = strategy;
        this.variations = variations;
    }
}

export default Product;